<template>
  <ion-page>
    <ion-content :class="'main-background'" :fullscreen="true" slot="fixed"
      :scroll-y="false">
      <ion-button @click="navigate('login')" class="header-button bg-transparent">
        <ion-icon slot="start" :icon="arrowBackOutline"></ion-icon>
      </ion-button>
      <ion-card class="bg-transparent">
        <ion-card-header class="ion-text-center white-bold">Регистрация</ion-card-header>
        <ion-card-content>
          <ion-input type="email" inputmode="email" placeholder="Электронная почта"
            v-model="registerAccount.email"></ion-input>
          <ion-input type="text" placeholder="Имя" v-model="registerAccount.firstName"></ion-input>
          <ion-input type="text" placeholder="Фамилия" v-model="registerAccount.lastName"></ion-input>
          <ion-input type="password" placeholder="Пароль" v-model="registerAccount.password"></ion-input>
          <ion-input type="password" placeholder="Пароль еще раз" v-model="confirmPassword"></ion-input>
          <div class="main-button-container">
            <ion-button v-on:click="singUp()" class="signup-button">
              Регистрация
            </ion-button>
          </div>
        </ion-card-content>
      </ion-card>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { GlobalContext } from '@/model/globalcontext.model';
import router from '@/router/index';
import store from '@/store/index';
import { CapacitorHttp } from '@capacitor/core';
import {
    IonButton,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonContent,
    IonIcon,
    IonInput,
    IonPage,
    alertController,
} from '@ionic/vue';
import axios from 'axios';
import { arrowBackOutline } from 'ionicons/icons';
import { defineComponent, inject } from 'vue';

export default defineComponent({
  props: {
    timeout: { type: Number, default: 1000 },
  },
  name: 'SignUp',
  components: {
    IonContent,
    IonPage,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonInput,
    IonButton,
    IonIcon,
  },
  setup() {
    const emailPattern = new RegExp('[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{2,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})');
    const globalContext = inject('globalContext') as GlobalContext;
    const isMobile = globalContext.isMobile;

    return {
      arrowBackOutline,
      emailPattern,
      isMobile,
    }
  },
  data() {
    return {
      registerAccount: {
        login: '',
        email: '',
        firstName: '',
        lastName: '',
        password: ''
      },
      confirmPassword: '',
    }
  },

  ionViewWillEnter() {
    this.registerAccount = {
      login: '',
      email: '',
      firstName: '',
      lastName: '',
      password: ''
    };
    this.confirmPassword = '';
  },

  computed: {
    isAuthenticated: () => {
      return store.getters.authenticated;
    },
  },

  methods: {
    navigate(routeName: string): void {
      router.push(`/${routeName}`);
    },

    singUp(): void {
      if (this.registerAccount.email.trim().length < 1 || !this.emailPattern.test(this.registerAccount.email.trim().toLowerCase())) {
        this.showAlert('Ошибка', 'Укажите корректный адрес электронной почты');
        return;
      } else if (this.registerAccount.firstName.trim().length < 1) {
        this.showAlert('Ошибка', 'Укажите Ваше имя');
        return;
      } else if (this.registerAccount.lastName.trim().length < 1) {
        this.showAlert('Ошибка', 'Укажите Вашу фамилию');
        return;
      } else if (this.registerAccount.password.length < 4) {
        this.showAlert('Ошибка', 'Пароль должен быть не менее 4 символов');
        return;
      } else if (this.registerAccount.password !== this.confirmPassword) {
        this.showAlert('Ошибка', 'Указанные пароли не совпадают');
        return;
      }

      const data = {
        login: this.registerAccount.email,
        email: this.registerAccount.email,
        firstName: this.registerAccount.firstName,
        lastName: this.registerAccount.lastName,
        password: this.registerAccount.password,
      };

      if (this.isMobile) {
        const options = {
          url: `${process.env.VUE_APP_API_URL}api/signup`,
          data: data,
          headers: {
            'Content-Type': 'application/json'
          }
        };
        CapacitorHttp.post(options)
          .then((response) => {
            if (response.status === 400) {
              this.showAlert('Ошибка', 'Попробуйте другой email');
            } else {
              this.showAlert('Сообщение', 'Вы успешно зарегистрированы! Дождитесь активации аккаунта.');
              this.navigate('login');
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        axios
          .post('api/signup', data, {
            headers: { 'Content-Type': 'application/json' }
          })
          .then((response) => {
            if (response.status === 400) {
              this.showAlert('Ошибка', 'Попробуйте другой email');
            } else {
              this.showAlert('Сообщение', 'Вы успешно зарегистрированы! Дождитесь активации аккаунта.');
              this.navigate('login');
            }
          })
          .catch((err) => {
            if (err.message === 'Request failed with status code 400') {
              this.showAlert('Ошибка', 'Попробуйте другой email');
            }
          });
      }
    },

    async showAlert(alertTitle: string, alertMessage: string) {
      const alert = await alertController
        .create({
          header: alertTitle,
          message: alertMessage,
          buttons: ['OK'],
        });

      await alert.present();
    }
  }
});
</script>

<style scoped>
ion-card {
  margin-top: 15vh;
}

ion-card-header {
  letter-spacing: .08em;
  font-size: 2em;
}

ion-input {
  --background: #434343;
  border-radius: 25px;
  opacity: .8;
  font-family: 'Montserrat';
  margin-bottom: 2em;
  color: white;
  --padding-start: 2em;
  --padding-end: 2em;
}

.signup-button {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  width: 280px;
  height: 50px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  --border-radius: 14px;
}

.main-button-container {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

.signup-container {
  margin-top: 2vh;
  display: flex;
  flex: row nowrap;
  justify-content: space-between;
  color: white;
  font-family: 'Montserrat';
}</style>